import firebase from 'firebase/app'
import 'firebase/firestore'

// Get a Firestore instance
const firebaseConfig = {
    projectId: "tracking-superskill",
};

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const Timestamp = firebase.firestore;

export { db, Timestamp };

